export default "__VITE_ASSET__ovmTBeLB__"